<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>


      <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="false"
      ></loading>

      <div class="info">
        La unificación desactivará a los pacientes duplicados del sistema
        asignando ciertos registros al paciente que se elija como original.
      </div>

      <div class="flxDiv">
        <div class="itmDiv grayDiv">
          <h4>Búsqueda por Nombres</h4>
          <div class="modalBody">
            <div class="searchPatient">
              <div class="SearchPti">
                <div class="bolderTxt hiddenDiv">Nombre del paciente:</div>
                <div class="inputBusqueda">
                  <b-form-input
                      v-model="pacienteSelect"
                      placeholder="Ingresa un nombre"
                      type="text"
                      v-on:keypress="isLetter($event)"
                  ></b-form-input>
                </div>
                <b-button variant="primary" @click="getPatients(pacienteSelect)"
                 :disabled="loaderPacxNombre">

                  <b-spinner v-if="loaderPacxNombre" small></b-spinner>
                  <b-icon v-else class="searchicon" icon="search"></b-icon
                  >
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div class="itmDiv grayDiv">
          <h4>Búsqueda por Id's</h4>
          <div class="modalBody">
            <div class="searchPatient">
              <div class="SearchPti">
                <div class="bolderTxt hiddenDiv">Id del paciente:</div>
                <div class="inputBusqueda">
                  <b-form-input
                      v-model="pacienteSeleccionado"
                      placeholder="Ingresa un id"
                      type="number"
                  ></b-form-input>
                </div>
                <b-button variant="primary" @click="obtenerPaciente"
                :disabled="loaderPacxID">
                  <b-spinner v-if="loaderPacxID" small></b-spinner>
                  <b-icon v-else class="searchicon" icon="search"></b-icon
                  >
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pacientesDetalleArray.length != 0">
      <span class="tablePatients">
        <h4>Resultados de la búsqueda</h4>
        <br/>
        <b-table
            ref="tablaPacientes"
            thead-tr-class="columnas"
            :items="pacientesDetalleArray"
            :fields="encabezados"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            class="parrafos"
            v-bind="pacientesDetalleArray"
            responsive
        >
          <template v-slot:cell(ID)="row">
            {{ row.item.ID }}
          </template>
           <template v-slot:cell(nombre)="row">
                <span
                    v-if="row.item.estatusPacienteColor != null"
                    :style="'color:' + row.item.estatusPacienteColor"
                >
                  {{ row.item.nombre }}
                </span>
                <span v-else style="color: #000000">
                  {{ row.item.nombre }}
                </span>
          </template>

          <template v-slot:cell(saldo)="row">
            <span>
              {{ row.item.saldo | moneda }}
            </span>
          </template>

          <template v-slot:cell(adeudo)="row">
          <span style="color: red" v-if="row.item.adeudo > 0">{{
              row.item.adeudo | moneda
            }}</span>
          <span v-else>{{ row.item.adeudo | moneda }}</span>
        </template>

          <template v-slot:cell(porcentajeDatos)="row">
            <span>
              {{ row.item.porcentajeDatos }}%
            </span>
          </template>

          <template v-slot:cell(original)="row">
            <b-form-radio
                name="radio"
                @change="pacienteOriginalFunction(row.item.ID, row.item)"
            ></b-form-radio>
          </template>
          <template v-slot:cell(duplicado)="row">
            <b-form-checkbox
                v-on:change="verificarExistenDuplicados(row.item.duplicado)"
                v-model="row.item.duplicado"
                value="true"
                :disabled="row.item.ID == pacienteOriginal"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(correo)="row">
            <span v-if="row.item.correo != null">
              {{ row.item.correo }}
            </span>
            <span v-else> SIN DATO </span>
          </template>

          <template v-slot:cell(telefononPersona)="row">
            <span v-if="row.item.telefononPersona.length != 0">
              <span
                  v-for="(itm, index) in row.item.telefononPersona"
                  :key="index"
                  :value="index"
              >
                <span v-if="itm.Celular != null && itm.Celular !== 'null'">
                  Celular {{ itm.Celular }}</span
                >
                <span v-if="itm.Casa != null && itm.Casa !== 'null'">
                  Casa: {{ itm.Casa }}
                </span>
                <span v-if="itm.Trabajo != null && itm.Trabajo !== 'null'">
                  Trabajo: {{ itm.Trabajo }}
                </span>
              </span>
            </span>
            <span v-else> SIN DATO </span>
          </template>
          <template v-slot:cell(planesConvenios)="row">
            <span
                v-for="plan in row.item.planesConvenios"
                :key="plan.Id"
                :value="plan.Id"
            >
              {{ plan.nombre }}
            </span>
            <span v-if="row.item.planesConvenios.length == 0"> NO APLICA </span>
          </template>

          <template v-slot:cell(direccionPersona)="row">
            <span v-if="row.item.direccionPersona != null">
              {{ row.item.direccionPersona }}
            </span>
            <span v-else> SIN DATO </span>
          </template>




          <template #cell(mas)="row">
            <b-form-checkbox v-model="row.detailsShowing"
                             @change="row.toggleDetails">
          Ver..
            </b-form-checkbox>
          </template>

          <template #row-details="row">
               <DetallePacienteUnificacion
                   :row="row"
                   :encabezadosDatosFiscales="encabezadosDatosFiscales"
               />
          </template>
        </b-table>
        <b-pagination
            v-if="patientTable.length > 15"
            align="center"
            v-model="paginaActual"
            :total-rows="patientTable.length"
            :per-page="registrosPorPagina"
        ></b-pagination>
      </span>
        <div v-if="$localStorageService.can('BT_Upx_unificacion')">
          <b-button
              variant="primary"
              :disabled="pacienteOriginal == null || numDuplicados == 0"
              @click="abrirModalUnificacion"
              v-if="pacienteOriginal != null || numDuplicados > 0"
          >Unificar
          </b-button>
          <b-button  v-else
            variant="danger"
            disabled
          >Debes seleccionar un paciente como original y mínimo un duplicado.
          </b-button>
        </div>

<!--        <b-button v-else variant="info" class="btnEstilo" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>-->
        <br/>
        <br/>
      </div>
    </b-container>
    <b-modal hide-footer
             id="detalleUnificacion"
             v-model="showModal"
             :title="titulo"
             size="lg"
             centered>

      <b-form v-on:submit.prevent="enviarFormulario">
        <detalle-unificacion
            :correoOriginal.sync="correoOriginal"
            :telefonos.sync="telefonos"
            :patientTable.sync="patientTable"
            :duplicados.sync="duplicados"
            :pacienteOriginal.sync="pacienteOriginal"
            :pacienteOriginalExtranjer.sync="pacienteOriginalExtranjero"
            :historiaSeleccionada.sync="historiaSeleccionada"
            :kpiSeleccionado.sync="kpiSeleccionado"
            :ptiSeleccionado.sync="ptiSeleccionado"
            :historiaRequerida.sync="historiaRequerida"
            @obtenerDuplicados="setearDuplicados"
            @obtenerEmail="setearEmail"
            @obtenerHistoria="setearHistoria"
            @obtenerKpi="setearKpi"
            @obtenerPti="setearPti"
        />

        <hr>
        <b-row>
          <b-col align="right" style="margin-top: 4px">
            <b-button-group>
              <b-button
                  class="mr-3"
                  variant="outline-primary"
                  size="sm"
                  type="submit"
              >
                <span v-if="!loaderAcciones">Guardar</span>
                <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
              </b-button>
              <b-button
                  variant="outline-danger"
                  size="sm"
                  @click="cerrarModal"
              >
                Cancelar
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-form>




    </b-modal>
  </div>


</template>

<script>
import miniToastr from "mini-toastr";
import moment from "moment";
import DetalleUnificacion from "@/components/unificacionPacientes/detalleUnificacion";
import DetallePacienteUnificacion from "@/components/unificacionPacientes/DetallePacienteUnificacion"; //ES6
export default {
  name: "unificacion",
  props: {
    msg: String,
  },
  components: {DetallePacienteUnificacion, DetalleUnificacion},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loaderAcciones : false,
    max: 14,
    showModal: false,
    pacienteOriginalExtranjero: false,
    titulo: null,
    patientTable: [],
    pacienteSelect: null,
    encabezados: [
      {key: "personaId", label: "ID persona"},
      {
        key: "ID",
        label: "ID paciente",
        sortable: true,
        sortDirection: "desc",
      },
      {key: "nombre", label: "Nombre del Paciente", sortable: true},
      {key: "fechaNacimiento", label: "Fecha de nacimiento"},
      {key: "adeudo", label: "Adeudo"},
      {key: "saldo", label: "Saldo"},
      {key: "direccionPersona", label: "Dirección"},
      {key: "telefononPersona", label: "Teléfono"},
      {key: "correo", label: "Email"},
      {key: "planesConvenios", label: "Convenio"},
      {key: "porcentajeDatos", label: "% de Datos"},
      {key: "mas", label: "Ver más"},
      {key: "original", label: "Original"},
      {key: "duplicado", label: "Duplicado"},
    ],
    encabezadosDatosFiscales: [
      {key: "rfc", label: "RFC"},
      {key: "domicilioFiscal", label: "Domicilio fiscal"}
    ],
    registrosPorPagina: 15,
    paginaActual: 1,
    loading: false,
    pacienteSeleccionado: null,
    pacienteOriginal: null,
    banderaBusquedaNombre: false,
    pacientesDetalleArray: [],
    btnDisabled: false,
    correoOriginal: null,
    telefonos: [],
    numeroCasa: null,
    numeroCelular: null,
    numeroTrabajo: null,
    duplicados: [],
    duplicadosGuardar: [],
    historiaSeleccionada: null,
    kpiSeleccionado: null,
    ptiSeleccionado: null,
    historiaRequerida: true,
    numDuplicados: 0,
    loaderPacxNombre: false,
    loaderPacxID: false
  }),

  methods: {
    cerrarModal(){
      this.historiaSeleccionada = null;
      this.kpiSeleccionado = null;
      this.$bvModal.hide("detalleUnificacion");
    },
    setearDuplicados(infoPacientesDuplicados) {
      this.duplicadosGuardar = infoPacientesDuplicados;
    },
    setearEmail(email) {
      this.correoOriginal = email;
    },
    setearHistoria(historia) {
      this.historiaSeleccionada = historia;
    },
    setearKpi(kpi) {
      this.kpiSeleccionado = kpi;
    },
    setearPti(pti) {
      this.ptiSeleccionado = pti;
    },
    enviarFormulario() {
      if (!this.validarDatos()) {
        this.crearUnificacion();
      }
    },
    crearUnificacion() {
      this.telefonos.forEach((item) => {
        if (item.tipo == "casa") {
          this.numeroCasa = item.numero;
        }

        if (item.tipo == "celular") {
          this.numeroCelular = item.numero;
        }

        if (item.tipo == "trabajo") {
          this.numeroTrabajo = item.numero;
        }
      });

      /* var pacientesDuplicados = this.patientTable.filter(function (item) {
         return item.duplicado == "true";
       });

       if (pacientesDuplicados.length == 0) {
         miniToastr.error("No hay pacientes duplicados seleccionados");
       } else {
         var arrayIds = pacientesDuplicados.map(function (item) {
           var data = {
             id: item.ID,
           };
           return data;
         });*/
      var params = {
        idOriginal: this.pacienteOriginal,
        duplicados: this.duplicadosGuardar,
        numeroCasa: this.numeroCasa,
        numeroCelular: this.numeroCelular,
        numeroTrabajo: this.numeroTrabajo,
        correo: this.correoOriginal,
        historiaSeleccionada: this.historiaSeleccionada,
        kpiSeleccionado: this.kpiSeleccionado,
        ptiSeleccionado: this.ptiSeleccionado,
        idUsuario: this.$localStorageService.getIdUsuario(),
      };

      this.$swal.fire({
        title: "¿Estás seguro de unificar el paciente?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          var message = "";
          this.btnDisabled = true;
          this.loaderAcciones = true;
          this.$http
              .post(this.$api + "paciente/unificar", params)
              .then((response) => {
                if (response.status === 200) {
                  if (!response.data.data) {
                    message = response.data.message
                        ? response.data.message
                        : "No se guardo la unificación";
                    miniToastr.error(message);
                    this.$swal({
                      icon: "error",
                      title: message,
                      showConfirmButton: false,
                      timer: 6000,
                    });
                  } else {
                    message = response.data.message
                        ? response.data.message
                        : "Se guardo correctamente el registro";
                    miniToastr.success(message);
                    this.$swal({
                      icon: "success",
                      title: "Se registro correctamente",
                      showConfirmButton: false,
                      timer: 6000,
                    });
                  }
                }
              })
              .catch((error) => {
                var message = error.response.data.message
                    ? error.response.data.message
                    : "Error al crear el registro";
                miniToastr.info(message);
                this.btnDisabled = false;
                this.loaderAcciones = false;
              })
              .finally(() => {
                this.btnDisabled = false;
                this.loaderAcciones = false;
                setTimeout(() => location.reload(), 6000);
              });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    validarDatos() {
      let error = false;
      if (this.historiaSeleccionada === null) {
        this.$swal({
          icon: "error",
          text:
              "Debe completar una historia clínica para poder unificar el paciente.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = true;
      }
      this.telefonos.forEach((item) => {
        if(item.numero !== null && item.numero !== ""){
         if (item.tipo === "celular"){
          if (item.numero.length !== 10) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "El Número Teléfonico  debe tener mínimo 10 digitos",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            error = true;
          }
         }
        }
      });
      return error;
    },
    pacienteOriginalFunction(id, item) {
      this.pacienteOriginal = id;
      this.correoOriginal = item.correo;
      this.pacienteOriginalExtranjero = item.extranjero;

      this.telefonos = [
        {
          tipo: "casa",
          numero: null,
        },
        {
          tipo: "celular",
          numero: null,
        },
        {
          tipo: "trabajo",
          numero: null,
        },
      ];

      this.telefonos.forEach((itm) => {
        item.telefononPersona.forEach((telPersona) => {
          if (itm.tipo == "casa" && telPersona.Casa != null) {
            itm.numero = telPersona.Casa;
            this.numeroCasa = telPersona.Casa;
          }

          if (itm.tipo == "celular" && telPersona.Celular != null) {
            itm.numero = telPersona.Celular;
            this.numeroCelular = telPersona.Celular;
          }

          if (itm.tipo == "trabajo" && telPersona.Trabajo != null) {
            itm.numero = telPersona.Trabajo;
            this.numeroTrabajo = telPersona.Trabajo;
          }
        });
      });

      if (item.duplicado == "true") {
        miniToastr.info(
            "El paciente seleccionado, esta seleccionado como duplicado"
        );
        item.duplicado = false;
        this.numDuplicados = 0;
      }
    },
    async getPatients(searchTerm) {
      this.loaderPacxNombre = true;
      this.loading = true;
      this.pacienteOriginal = null;

      this.correoOriginal = null;

      if (searchTerm != undefined && searchTerm.length > 3) {
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        await this.$http
            .post(
                this.$api +
                "paciente/perfiles/obtenerDatosPaciente",
                {
                  "nombrePaciente": inputTxt,
                  "busquedaAvanzada": false
                }
            )
            .then((response) => {
              if (response.status === 200) {
                this.pacientesDetalleArray = [];
                this.patientTable = [];
                this.numDuplicados = 0;
                this.banderaBusquedaNombre = true;
                if (Array.isArray(response.data.data) == true) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {
                    var data = {
                      ID: parseInt(elementDos.id),
                      nombre: elementDos.nombre,
                      duplicado: false,
                      estatusPacienteColor: elementDos.estatusPacienteColorDTO.color,
                      fechaNacimiento: moment(elementDos.fechaNacimiento)
                          .utc()
                          .format("DD/MM/YYYY"),
                      saldo: elementDos.saldo,
                      adeudo: elementDos.adeudo,
                    };
                    this.patientTable.push(data);
                    return data;
                  });

                  if (Array.isArray(this.patientTable) == true) {
                    this.patientTable.sort(function (a, b) {
                      if (a.id > b.ID) {
                        return 1;
                      }
                      if (a.id < b.ID) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              this.patientTable = [];
              this.pacientesDetalleArray = [];
              this.loaderPacxNombre = false;
              console.error(error);
            });
      }
      await this.actualizarDetallePaciente();
      this.loaderPacxNombre = false;
      this.loading = false;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ/^\s+$/]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async obtenerPaciente() {
      this.loading = true;
      this.loaderPacxID=true;
      this.pacienteOriginal = null;

      this.correoOriginal = null;
      this.numeroCasa = null;
      this.numeroCelular = null;
      this.numeroTrabajo = null;
      if (this.banderaBusquedaNombre == true) {
        this.patientTable = [];
        this.pacientesDetalleArray = [];
        this.banderaBusquedaNombre = false;
      }

      if (
          this.pacienteSeleccionado != null &&
          this.pacienteSeleccionado.length > 5 &&
          !isNaN(this.pacienteSeleccionado)
      ) {
        const params = {
          idPaciente: this.pacienteSeleccionado
        }
        let urlPacienteId =
            this.$api + "paciente/obtenerDatosPacienteId";

        await this.$http
            .post(urlPacienteId, params)
            .then((response) => {
              if (response.status === 200) {
                var data = {
                  ID: parseInt(response.data.data.id),
                  nombre: response.data.data.nombre,
                  duplicado: false,
                  estatusPacienteColor: response.data.data.estatusPacienteColorDTO.color,
                  saldo: response.data.data.saldo,
                  adeudo: response.data.data.adeudo
                };

                var pacienteExiste = this.patientTable.find(
                    (itm) => itm.ID == this.pacienteSeleccionado
                );

                if (pacienteExiste == undefined) {
                  this.patientTable.push(data);
                }
              }
            })
            .catch((error) => {
              miniToastr.error("No se encontró el paciente");

              console.error(error);
            });
      }
      await this.actualizarDetallePaciente();
      this.loaderPacxID=false;
      this.loading = false;
    },
    abrirModalUnificacion(item) {
      var pacientesDuplicados = this.patientTable.filter(function (item) {
        return item.duplicado == "true";
      });


      if (pacientesDuplicados.length == 0) {
        miniToastr.error("No hay pacientes duplicados seleccionados");
      } else {
        this.duplicados = pacientesDuplicados.map(function (item) {
          var data = {
            id: item.ID,
          };
          return data;
        });
      }

      this.titulo = 'Datos a unificar'
      this.datoFiscal = item;
      this.showModal = true;
    },
    obtenerPorcentajeDatos(itm){
      const total = 15;
      var numDatos = 0;
      var porcentaje = 0;
      if(itm.direccionPersona !== null && itm.direccionPersona !== ""){
        numDatos += 1;
      }
      if(itm.telefononPersona.length === 1){
        numDatos += 1;
      }
      if(itm.telefononPersona.length === 2){
        numDatos += 2;
      }
      if(itm.telefononPersona.length === 3){
        numDatos += 3;
      }
      if(itm.correo !== null && itm.correo !== ""){
        numDatos += 1;
      }
      if(itm.planesConvenios.length > 0){
        numDatos += 1;
      }
      if(itm.datosFiscales.length > 0){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneSesiones){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneProgramados){
        numDatos += 1;
      }
      if(itm.detalleDatos.tienePagos){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneFacturas){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneCitas){
        numDatos += 1;
      }
      if(itm.detalleDatos.tienePti){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneHistoria){
        numDatos += 1;
      }
      if(itm.detalleDatos.tieneHistoricos){
        numDatos += 1;
      }


      porcentaje = Math.ceil((numDatos/total*100).toFixed(2));

      return porcentaje;

    },
    verificarExistenDuplicados(item){
      if(item == false){
        this.numDuplicados += 1;
      }else{
        this.numDuplicados -= 1;
      }
    },
    async actualizarDetallePaciente() {
      for (const itm of this.patientTable) {
        //BUSCAR DATOS DE PACIENTES
        const params = {
          idPaciente: itm.ID
        }
        await this.$http
            .post(
                this.$api +
                "paciente/perfiles/obtenerDetallePacienteUnificacion", params
            )
            .then((response) => {
              if (response.status === 200) {
                var datos = response.data.data;
                itm.correo = datos.correo;
                itm.fechaNacimiento = moment(datos.fechaNacimiento)
                    .utc()
                    .format("DD/MM/YYYY");

                itm.telefononPersona = [];

                if (datos.telefonoCasa != null) {
                  itm.telefononPersona.push({Casa: datos.telefonoCasa});
                }

                if (datos.telefonoCelular != null) {
                  itm.telefononPersona.push({Celular: datos.telefonoCelular});
                }

                if (datos.telefonoTrabajo != null) {
                  itm.telefononPersona.push({Trabajo: datos.telefonoTrabajo});
                }

                itm.planesConvenios = datos.planesConvenios;

                itm.datosFiscales = datos.datosFiscales;
                itm.detalleDatos = datos.detalleDatos;

                var pacienteExiste = this.pacientesDetalleArray.find(
                    (itmDos) => itmDos.ID == itm.ID
                );

                itm.personaId = datos.personaId;

                itm.direccionPersona = datos.direccionPersona;

                itm.porcentajeDatos = (this.obtenerPorcentajeDatos(itm));

                itm.extranjero = datos.extranjero;


                if (pacienteExiste == undefined) {
                  this.pacientesDetalleArray.push(itm);
                }
              }
            })
      }
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style scoped>
.info {
  margin-top: 10px;
  background-color: #fff87c;
  border: 2px solid #fbb917;
  padding: 10px;
  border-radius: 10px;
}

.flxDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
}

.itmDiv {
  margin-top: 20px;
  margin-bottom: 20px;

  width: 48%;
}

.grayDiv {
  margin: 10px;
  border-radius: 3px 0 0 0;
  border: 1px solid #ddd;
  padding: 10px;
}

.template {
  width: 100%;
}

.colorHeader {
  background-color: #f6f6f6;
}

.headerTxt {
  font-weight: bold;
}

.SearchPti {
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.inputBusqueda {
  width: 70%;
}

.swal2-title {
  font-size: 20px !important;
}

.mginTop {
  margin-top: 30px !important;
}

.searchPatient {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  padding-left: 10px;
}

.searchicon {
  color: white !important;
  font-size: 16px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bolderTxt {
  font-size: 14px;
  font-weight: bolder;
  width: 20%;
  margin-left: 15px;
}

.spanCien {
  width: 100% !important;
  padding-top: 5px;
  padding-bottom: 5px;
}

.inputFlex {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.inputDiv {
  margin-top: 10px;
  width: 90%;
}

.boldTxt {
  font-weight: bolder;
}
</style>
